import { NgZorroModule } from './../../ng-zorro.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrmRoutingModule } from './crm-routing.module';
import { HomeComponent } from './home/home.component';
import { IndexComponent } from './index/index.component';
import { LayoutModule } from 'src/app/layout/layout.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { CalendarModule } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import * as moment from 'moment';
import { CalendarComponent } from './calendar/calendar.component';
import { FormsModule } from '@angular/forms';
import { CreateCampaignComponent } from './create-campaign/create-campaign.component';
import { ClassDistributerPipe } from './pipes/classDistributer.pipe';
import { SelectionStylingPipe } from './pipes/selectionStyling.pipe';
import { EmailsConfigurationComponent } from './emails-configuration/emails-configuration.component';
import { EmailFromPipe } from './emails-configuration/pipes/email-from.pipe';
import { ApprovalDecisionReportComponent } from './approval-decision-report/approval-decision-report.component';
import { ReturnWizardComponent } from './return-wizard/return-wizard.component';
export function momentAdapterFactory() {
  return adapterFactory(moment);
}

@NgModule({
  declarations: [
    HomeComponent,
    IndexComponent,
    CalendarComponent,
    CreateCampaignComponent,
    ClassDistributerPipe,
    SelectionStylingPipe,
    EmailsConfigurationComponent,
    EmailFromPipe,
    ReturnWizardComponent,
    ApprovalDecisionReportComponent,
    ReturnWizardComponent,
  ],
  imports: [
    CommonModule,
    CrmRoutingModule,
    NgZorroModule,
    LayoutModule,
    DashboardModule,
    CalendarModule,
    FormsModule,
  ],
})
export class CrmModule {}
